import { useQuery, UseQueryResult } from 'react-query';
import type { TControls } from 'src/types';
import { httpClient } from 'src/utils/HttpClients';

type TControlResponse = {
    data: TControls;
};

export const useControls = (enabled?: boolean): UseQueryResult<TControls> => {
    const queryFn = async () => {
        const { data } = await httpClient.get<TControlResponse>('/control');
        return data.data;
    };

    return useQuery(['controls'], queryFn, { keepPreviousData: false, enabled });
};
